import { render } from "./GoTop.vue?vue&type=template&id=0d08262d&scoped=true"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"

import "./GoTop.vue?vue&type=style&index=0&id=0d08262d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d08262d"

export default script